<app-header [label]="page_name"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
  <div class="flex items-center gap-3 flex-1">
    <app-select-input class="w-[160px] shrink-0" label="Academic Year" [(ngModel)]="academic_year_id" [options]="ds.dropdown_list?.academic_list" (valueChange)="on_academic_year_change($event)">
    </app-select-input>
    <app-select-input #exam_dropdown class="flex-1" label="Exam Name" [options]="student_exam_list" [patch_first_value]="true" (valueChange)="on_exam_change($event)">
    </app-select-input>
  </div>
  <div class="flex items-center gap-2 shrink-0">
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <button (click)="download()" class="w-10 h-10 flex items-center justify-center rounded-full border border-[#3F41D1] text-[#3F41D1] hover:bg-indigo-50 transition-all shrink-0">
      <i class="bx bx-download text-xl"></i>
    </button>
  </div>
</div>

<app-ag-grid-list [list]="items" [colDefs]="city_cols" [itemName]="page_name" [bulk_delete]="false" [show_checkboxes]="false" (fetch_new_list)="get_list($event)"></app-ag-grid-list>

<app-modal #re_evaluate_modal [label]="'Re-evaluation Request'" [max_width]="'448px'">
  <div class="h-full flex flex-col gap-4">
    <div class="bg-gray-50 p-4 rounded-xl border border-gray-200">
      <div class="grid grid-cols-1 sm:grid-cols-1 gap-y-3 gap-x-8 text-gray-700 text-sm">
        <div class="flex justify-between w-full"><span class="font-medium text-gray-500">Roll No:</span><span class="font-semibold text-gray-900">{{ selected_item?.roll_number || 'N/A' }}</span></div>
        <div class="flex justify-between w-full"><span class="font-medium text-gray-500">Subject (Code):</span><span class="font-semibold text-gray-900">{{ selected_item?.subject?.name || 'N/A' }} ({{ selected_item?.subject?.code || 'N/A' }})</span></div>
        <div class="flex justify-between w-full"><span class="font-medium text-gray-500">Total Marks:</span><span class="font-semibold text-gray-900">{{ selected_item?.total_marks || 'N/A' }}</span></div>
        <div class="flex justify-between w-full"><span class="font-medium text-gray-500">Marks Obtained:</span><span class="font-semibold text-gray-900">{{ selected_item?.marks_obtained !== null && selected_item?.marks_obtained !== undefined ? selected_item?.marks_obtained : 'N/A' }}</span></div>
        <div class="flex justify-between w-full items-center"><span class="font-medium text-gray-500">Result:</span><span class="font-medium" [ngClass]="{'text-green-600': selected_item?.result_status === 'Passed', 'text-red-600': selected_item?.result_status === 'Failed', 'text-yellow-600': selected_item?.result_status === 'Pending'}">{{ selected_item?.result_status || 'Pending' }}</span></div>
      </div>
    </div>

    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-2">Reason for Re-evaluation <span class="text-red-600">*</span></label>
      <app-select-input [(ngModel)]="re_evaluation_reason" [options]="re_evaluation_reasons" placeholder="Select a reason" class="w-full">
      </app-select-input>
    </div>
    @if(needs_payment()) {
    <div class="bg-indigo-50 border border-primary rounded-lg px-4 py-2 flex items-center justify-start gap-2">
      <span class="text-[#312C85] font-medium">Re-evaluation Fees:</span>
      <span class="text-[#312C85] font-medium text-lg">₹{{ selected_item?.re_evaluation_details?.amount }}</span>
    </div>
    } @else {
    <div class="bg-indigo-50 border border-primary rounded-lg px-4 py-2 flex items-center justify-start gap-2">
      <span class="text-[#312C85] font-medium">Re-evaluation Fees:</span>
      <span class="text-[#312C85] font-medium text-lg">Free</span>
    </div>
    }
    <p class="text-gray-600 text-sm leading-relaxed">Please confirm if you want to proceed with the re-evaluation for this subject?</p>
    <div class="flex justify-between items-center gap-3 mt-auto w-full">
      <app-button color="border-gray-300 text-gray-600 w-full" label="Cancel" type="button" (click)="cancel_re_evaluate()">
      </app-button>
      <app-button color="bg-primary text-white w-full" [label]="needs_payment() ? 'Pay & Apply' : 'Apply'" type="button" [submit]="apply_re_evaluation.bind(this)">
      </app-button>
    </div>
  </div>
</app-modal>